import React from 'react'
import { ContactInstrument, InstrumentType } from 'types/contacts'
import { CryptoAddressSidePanelBody } from './CryptoInstrument/CryptoAddressSidePanelBody'
import { BankAccountSidePanelBody } from './FiatInstrument/BankAccountSidePanelBody'

export interface ContactInstrumentsSidePanelBodyProps {
  contactInstrument: ContactInstrument
}

export const ContactInstrumentsSidePanelBody = ({
  contactInstrument,
}: ContactInstrumentsSidePanelBodyProps) => {
  switch (contactInstrument?.type) {
    case InstrumentType.CRYPTO:
      return <CryptoAddressSidePanelBody contactInstrument={contactInstrument} />
    case InstrumentType.BANK_ACCOUNT:
      return <BankAccountSidePanelBody contactInstrument={contactInstrument} />
    default:
      return null
  }
}
